import { buildPxCheck } from '../utils/buildPxCheck';
import { validatePxConfigurations } from 'utils';
import { sanitizeRedeemOnlyCheck } from '../utils/discountUtil';

const REDEEM_ONLY_API_ENDPOINT_PATH = '/check/redeemOnly.json';

function buildRequest(posContext, order, compCard) {
  const discountUidsForCard = (order.discounts || [])
    .filter((d) => d.metadata?.pxCompCardId === compCard?.compCardId)
    .map((d) => d.uid);

  const preSanitizedCheck = buildPxCheck(order, compCard?.compCardId);
  const check = sanitizeRedeemOnlyCheck(preSanitizedCheck, discountUidsForCard);

  const cardInfo = {
    printedCardNumber: compCard?.compCardId,
  };

  return {
    merchantId: Number(posContext.configurations.merchantId),
    storeCode: posContext.configurations.storeCode,
    check,
    cardInfo,
    autoActivateCard: true,
    terminal: posContext.device.id ?? '0',
    operator: posContext.employee.id ?? '0',
    rewardSelectionMode: {
      mode: 'manual',
      chosenRewards: compCard?.compDiscounts,
    },
    receiptSettings: [],
  };
}

export function isSuccessResponse(response) {
  return response.result === 'success';
}

export function isFailureResponse(response) {
  return response.result === 'failure';
}

export async function redeemOnly(posContext, pxContext, order, compCard) {
  const request = buildRequest(posContext, order, compCard);
  const validatedPxConfigurations = validatePxConfigurations(
    posContext.configurations
  );
  const paytronixDomain = validatedPxConfigurations.environmentUrl;
  const response = await fetch(
    `${paytronixDomain}${REDEEM_ONLY_API_ENDPOINT_PATH}`,
    {
      body: JSON.stringify(request),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Basic ${pxContext.authorizationToken}`,
      },
    }
  ).then((result) => result.json());

  return response;
}
